/* 
    非元数据组件
    created by: liyaoh 2019-04-30
*/
import React, { Component } from 'react';
import { langCheck } from 'Pub/js/utils';
import DragArea from '../DragArea';
import NotMetaItem from './NotMetaItem';
import { dataTypeObj } from "../../utilService";

class NotMetaData extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { json ,templettype } = this.props;
        const notMetaData = dataTypeObj();
        // // 只有移动非元数据有附件
        // if(templettype !== "mobile") {
        //     notMetaData.pop();
        // }
        return (
            <DragArea 
                headerTitle={langCheck('ZoneSetting-000202', 'pages', json)}/* 国际化处理： 非元数据 */
            >
                {
                    notMetaData.map(item => {
                        return <NotMetaItem items={item}/>
                    })
                }
            </DragArea>
        );
    }
}

export default NotMetaData;